import { render, staticRenderFns } from "./App.vue?vue&type=template&id=55520410"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=55520410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports